import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { toast } from '@hub-la/shadcn'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { CancelRefundRequestInput } from '../../domain/dtos/cancel-refund-request-input'
import { QueryKey } from '../../domain/enums/query-key'
import { CancelRefundRequest } from '../../usecases/cancel-refund-request'

export const useCancelRefundRequest = () => {
  const container = useContainer()
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation(
    [QueryKey.patchCancelRefundRequest],
    (input: CancelRefundRequestInput) => new CancelRefundRequest(container.get(HttpClient)).execute(input),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.getRefunds] })
      },
      onError: () => {
        toast({ description: t("errors.general"), variant: "destructive" })
      }
    },
  )
}
